"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabtracProductGroup_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LabtracLab_1 = require("./LabtracLab");
var LabtracProduct_1 = require("./LabtracProduct");
var LabtracProductGroup_Factory = /** @class */ (function () {
    function LabtracProductGroup_Factory() {
    }
    LabtracProductGroup_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ExternalId: model.ExternalId,
            LabReference: model.LabReference,
            LabtracLab: LabtracLab_1.LabtracLab_Factory.CreateIncoming(model.LabtracLab),
            LabtracLabId: model.LabtracLabId,
            LabtracProducts: model.LabtracProducts && model.LabtracProducts.map(function (i) { return LabtracProduct_1.LabtracProduct_Factory.CreateIncoming(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    LabtracProductGroup_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ExternalId: model.ExternalId,
            LabReference: model.LabReference,
            LabtracLab: LabtracLab_1.LabtracLab_Factory.CreateOutgoing(model.LabtracLab),
            LabtracLabId: model.LabtracLabId,
            LabtracProducts: model.LabtracProducts && model.LabtracProducts.map(function (i) { return LabtracProduct_1.LabtracProduct_Factory.CreateOutgoing(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return LabtracProductGroup_Factory;
}());
exports.LabtracProductGroup_Factory = LabtracProductGroup_Factory;
